import React, { FC } from 'react';
import { AnalyticsSenderProvider } from '@funtech-int/yango-shared';

import { useHasSubscription } from '@/shared/hooks/useHasSubscription';
import { AutoOpenPaymentWidget } from '@/shared/components/AutoOpenPaymentWidget/AutoOpenPaymentWidget';
import { ChannelListContainer } from '@/scenarios/channels/components/ChannelList/ChannelList';
import { PageId } from '@/shared/types/pathId';
import { useHeaderItems } from '@/shared/hooks/useHeaderItems';
import { TabList } from '@/shared/components/TabList';
// TODO: отказаться от прямого импорта когда перейдем на @/scenarios/player https://st.yandex-team.ru/SAFT-8848
import { PlayerManager } from '@/scenarios/legacy-player/components/PlayerManager/PlayerManagerMain';
import { clientOnlyPage } from '@/shared/lib/clientOnly';
import { clientConfig } from '@/config/client';
import { RememberedPages, useRemeberPage } from '@/shared/hooks/userRememberPage';

import { useChannelCategoryTabQueryParam } from '../../hooks/useChannelCategoryTabQueryParam';
import { useSetChannelCategoryTabQueryParam } from '../../hooks/useSetChannelCategoryTabQueryParam';
import { useChannelCategoryList } from '../../hooks/useChannelCategoryList';
import { useI18n } from '../../hooks/useI18n';
import { ChannelsPaywall } from '../ChannelsPaywall/ChannelsPaywallComponent';
import { useInitialOpenedChannelIdQueryParam } from '../../hooks/useOpenedChannelIdQueryParam';
import { ChannelsPageHead } from '../ChannelsPageHead/ChannelsPageHead';

import { ChannelUrlParamHandlerClient } from './ChannelUrlParamHandler';
import styles from './ChannelsPage.module.css';

const { channelsPaywall } = clientConfig;

const ChannelsPage = () => {
    useRemeberPage(RememberedPages.LiveTV);
    const i18n = useI18n();
    const activeMenuItemTitles = useHeaderItems();
    const hasSubscription = useHasSubscription();

    const channelCategories = useChannelCategoryList();
    const openedChannelId = useInitialOpenedChannelIdQueryParam();

    const channelCategoryTabId = useChannelCategoryTabQueryParam();
    const setChannelCategoryTabId = useSetChannelCategoryTabQueryParam();
    const isChannelsPaywallEnabled =
        channelsPaywall.isEnabled &&
        !hasSubscription &&
        activeMenuItemTitles.includes(PageId.CHANNELS);

    const hasChannelCategories = Boolean(channelCategories.length);
    const channelDescription = channelCategories.find(
        (category) => category.id === channelCategoryTabId
    )?.description;

    return (
        <div className={styles.root}>
            {openedChannelId && <ChannelUrlParamHandlerClient openedChannelId={openedChannelId} />}
            {isChannelsPaywallEnabled ? (
                <ChannelsPaywall />
            ) : (
                <h1 className={styles.title}>{i18n('channels_page_title')}</h1>
            )}
            {hasChannelCategories && (
                <div className={styles.tabs}>
                    <TabList
                        hasDropDownList
                        tabs={channelCategories}
                        onChange={setChannelCategoryTabId}
                        itemClassName={styles.tabItem}
                        selected={channelCategoryTabId}
                        dropDownButtonLabel={i18n('channels_dropdown_button_label')}
                    />
                </div>
            )}
            <main>
                <ChannelListContainer />
            </main>
            {channelDescription && (
                <div className={styles.description}>
                    <p className={styles.descriptionText}>{channelDescription}</p>
                </div>
            )}
        </div>
    );
};

const ChannelsPageContainer = clientOnlyPage(() => (
    <>
        <PlayerManager />
        <AnalyticsSenderProvider>
            <ChannelsPage />
            <AutoOpenPaymentWidget />
        </AnalyticsSenderProvider>
    </>
));

export const Channels: FC = () => (
    <>
        <ChannelsPageHead />
        <ChannelsPageContainer />
    </>
);

export default Channels;
